const FallingChart = () => {
    return (
        <svg width="37" height="16" viewBox="0 0 37 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M36 15L35.5042 14.471C35.0375 13.9419 34.0458 12.8839 33.0833 12.3549C32.1208 11.8258 31.1292 11.8258 30.1667 9.70971C29.2042 7.59359 28.2125 3.36136 27.25 1.77427C26.2875 0.187181 25.2958 1.24524 24.3333 3.09684C23.3708 4.94844 22.3792 7.59359 21.4167 8.65165C20.4542 9.70971 19.4625 9.18068 18.5 8.65165C17.5375 8.12262 16.5458 7.59359 15.5833 8.12262C14.6208 8.65165 13.6292 10.2387 12.6667 11.2968C11.7042 12.3549 10.7125 12.8839 9.75 12.8839C8.7875 12.8839 7.79583 12.3549 6.83333 11.0323C5.87083 9.70971 4.87917 7.59359 3.91667 7.59359C2.95417 7.59359 1.9625 9.7097 1.49583 10.7678L1 11.8258"
                stroke="#DF2040" stroke-width="2" stroke-linecap="round"/>
        </svg>
    )
}

export default FallingChart